// ============================================================
// 📁 src/index.tsx   (جایگزین فایل قبلی — فایل قبلی با نام indexMain.tsx می‌ماند)
// تصمیم‌گیری زود: پنل مالک و ثبت‌نام آزمایشی (khanbaba.net)، پورتال مشتری (/portal)،
// در غیر این صورت همان برنامه‌ی قبلی (indexMain) بدون هیچ تغییری بالا می‌آید.
// برای برنامه‌ی شرکت و پورتال: نوار زمان باقی‌مانده/قفل اشتراک + خط پایین گزارش‌ها.
// ============================================================
import { createRoot } from "react-dom/client";
import { initI18n } from "./i18n";

const host = window.location.hostname.toLowerCase();
const path = window.location.pathname;
const isCentral = host === "khanbaba.net" || host === "www.khanbaba.net";
const isTrial = isCentral && (path === "/trial" || path.startsWith("/trial/"));
const isPortal = !isCentral && (path === "/portal" || path.startsWith("/portal/"));

// اول زبان و دیکشنری بارگذاری می‌شود، بعد برنامه (تا t() بالای فایل‌ها هم درست کار کند)
initI18n().then(async lang => {
  const { installReportPromo } = await import("./utils/promo");
  const { startSubscriptionWatch } = await import("./utils/subscriptionWatch");
  if (isCentral || isPortal) {
    const el = document.getElementById("root") as HTMLElement;
    document.documentElement.setAttribute("dir", "rtl");
    document.documentElement.setAttribute("lang", lang);
    if (isPortal) { installReportPromo(); startSubscriptionWatch("portal"); }
    const load = isTrial ? import("./pages/trial/TrialApp") : isCentral ? import("./pages/owner/OwnerApp") : import("./pages/portal/PortalApp");
    load.then(m => {
      const Comp = m.default;
      createRoot(el).render(<Comp />);
    });
  } else {
    installReportPromo();
    startSubscriptionWatch("staff");
    import("./indexMain");
  }
});
